import { createContext, useContext, useState, useEffect } from 'react';
import { ALL_TIP_IDS } from '../lib/helpTips';

const HelpTipsContext = createContext(null);

export function HelpTipsProvider({ showTips, onAllDismissed, children }) {
  const [dismissedTips, setDismissedTips] = useState(() => new Set());

  // Clear dismissed state whenever tips are re-enabled (Settings toggle ON)
  useEffect(() => {
    if (showTips) setDismissedTips(new Set());
  }, [showTips]);

  function dismissTip(id) {
    setDismissedTips(prev => {
      const next = new Set([...prev, id]);
      if (onAllDismissed && ALL_TIP_IDS.every(tid => next.has(tid))) {
        onAllDismissed();
      }
      return next;
    });
  }

  function isVisible(id) {
    return !!(showTips && !dismissedTips.has(id));
  }

  return (
    <HelpTipsContext.Provider value={{ showTips, isVisible, dismissTip }}>
      {children}
    </HelpTipsContext.Provider>
  );
}

export function useHelpTips() {
  const ctx = useContext(HelpTipsContext);
  // Graceful fallback when rendered outside provider
  if (!ctx) return { showTips: false, isVisible: () => false, dismissTip: () => {} };
  return ctx;
}
